import React from 'react'
import Questions_Table from '../../utilities/tableQuestionnaire/questionnaire_custom_answers'
import {Container,Table} from 'react-bootstrap';
import Title from '../../utilities/other/title';
import data  from './psp_ds_data.json';
class PspDs extends React.Component {
    constructor(props) {
        super(props)
        this.state ={score:0}
    }
    handleScore = (val) => {
        if (!isNaN(val)){
            this.setState((prevState) => 
                        ({
                            ...prevState,
                            score:prevState.score + (val)

                        })
                        
            )
        }
        
    }
    onChange = async (event)=>{
        const {name,value} = event.target
        
      await  this.setState((prevState)=>({
            ...prevState,
            
           
                [name]:value
            
        }))
       await this.props.handler('psp_cds',this.state)
    }
    // componentDidUpdate(prevProps, prevState){
    //     if (prevState != this.state){
    //        this.props.handler('psp_cds',this.state)
    //     }
    // }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }

    render() {
        return (
            <Container>
                <Title>Progressive Supranuclear Palsy  Clinical Deflicts Scale</Title>
                <Questions_Table  disabled={this.props.disabled} score={true} scoreFunc={this.handleScore} data={this.props.data} questions={data} answers={data} handler={this.onChange} fieldName={'psp-ds'}/>
                <Table>
                                <thead>
                                    <tr>
                                        <th>Score:</th>
                                        <th width={100}>{this.state.score}</th>
                                    </tr>
                                </thead>
                            </Table>
            </Container>
        )
    }
}
PspDs.defaultProps = {
    data:null,
    disabled:false
}
export default PspDs